// extracted by mini-css-extract-plugin
module.exports = {"slider":"ModalSlider_slider__1fKXo"};